import createClient from 'openapi-fetch';

import { paths } from './schema';

export const locationApiClient = createClient<paths>({
  baseUrl: 'https://kr5iknsvo9.execute-api.us-east-2.amazonaws.com',
});
